import { Route, Redirect } from 'react-router-dom';
import Package from "../pages/package/Package";

// NB SONO QUI

export default (netsRoute) => {
  return [
    <Route
      exact
      path={`/${netsRoute}/:parentCategory/package/:package.html`}
      component={Package}
      key={`${netsRoute}packageRoute`}
    />,
  ];
};
